import { render, staticRenderFns } from "./BusinessValueResultsPage.vue?vue&type=template&id=5fce293d&scoped=true"
import script from "./BusinessValueResultsPage.vue?vue&type=script&lang=ts"
export * from "./BusinessValueResultsPage.vue?vue&type=script&lang=ts"
import style0 from "./BusinessValueResultsPage.vue?vue&type=style&index=0&id=5fce293d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fce293d",
  null
  
)

export default component.exports